export default __webpack_public_path__ + "static/media/187.9c8f7d52.jpg";